import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { updateTeam } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { ...rest } = values;
  return {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useUpdateTeam() {
  return useMutation({
    mutationFn: async ({ item, teamId }) => {
      const payload = buildPayload(item);
      const response = await updateTeam({ item: payload, teamId });
      return response;
    },
    onSuccess: () => {
      toast.success("Team Updated Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
